/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

@translate()
@inject('projectDetailsStore')
@observer
class ProjectDetails extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;

    const details: any = this.props;

    const getChildData: Function = (child: string, val: string) => {
      return typeof details[child] === 'undefined' ? null : details[child][val];
    };

    return (
      <React.Fragment>
        <h3>{t('general:projects.labels.details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:trading_accounts.labels.name')}:</b>
              </td>
              <td>{getChildData('trading_account', 'name')}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:trading_accounts.labels.number')}:</b>
              </td>
              <td>{getChildData('trading_account', 'account_no')}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.name')}:</b>
              </td>
              <td>{details.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.code')}:</b>
              </td>
              <td>{details.code}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.description')}:</b>
              </td>
              <td>{details.description}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.start_date')}:</b>
              </td>
              <td>
                <Moment date={details.start_date} format="MMMM DD, YYYY" />
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.end_date')}:</b>
              </td>
              <td>
                <Moment date={details.end_date} format="MMMM DD, YYYY" />
              </td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default ProjectDetails;
